import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";

const ContactsPage = () => {
  const [contacts, setContacts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const contactsRef = ref(database, "contacts/");
    onValue(contactsRef, (snapshot) => {
      const contactsData = snapshot.val();
      const contactsArray = contactsData
        ? Object.keys(contactsData).map((key) => ({
            id: key,
            ...contactsData[key],
          }))
        : [];
      setContacts(contactsArray);
    });
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <button
        onClick={() => navigate(-1)} // Navigate back to the previous page
        className="mb-4 bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600"
      >
        Back
      </button>
      <h1 className="text-3xl font-bold text-center mb-6">Contacts</h1>
      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-white shadow-lg rounded-lg">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-4 py-2">First Name</th>
              <th className="px-4 py-2">Last Name</th>
              <th className="px-4 py-2">Mobile Number</th>
              <th className="px-4 py-2">Email</th>
              <th className="px-4 py-2">Message</th>
              <th className="px-4 py-2">Service Type</th>
              <th className="px-4 py-2">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {contacts.length > 0 ? (
              contacts.map((contact) => (
                <tr key={contact.id} className="text-center">
                  <td className="border px-4 py-2">{contact.firstName}</td>
                  <td className="border px-4 py-2">{contact.secondName}</td>
                  <td className="border px-4 py-2">{contact.mobile}</td>
                  <td className="border px-4 py-2">{contact.email}</td>
                  <td className="border px-4 py-2">{contact.message}</td>
                  <td className="border px-4 py-2">{contact.serviceType}</td>
                  <td className="border px-4 py-2">
                    {new Date(contact.timestamp).toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="text-center text-gray-500 py-4"
                >
                  No contact requests available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactsPage;

